import React from 'react'
import { styled } from "../../../stitches.config";
import Media from "../../../components/common/Media";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type PersonLabelProps = {
    name: string,
    role: string,
    image: string,
    size: string,
    location: {
        mobile: string[],
        desktop: string[],
    },
    isDesktop: boolean,
}

const PersonLabel = ({ name, role, image, size, location, isDesktop }: PersonLabelProps) => {
    return (
        <Card style={isDesktop ? { top: location.desktop[0], right: location.desktop[1], borderRadius: size, height: size } : { top: location.mobile[0], right: location.mobile[1], borderRadius: size, height: size }}>
            <Image style={size == '96px' ? { width: '72px', height: '72px' } : { width: '47px', height: '47px' }}>
                <Media src={image} disablePreload={true} />
            </Image>
            <div style={{ display: isDesktop ? 'block' : 'none' }}>
                <h4 style={{ margin: 0, padding: 0 }}>{name}</h4>
                <p style={{ margin: 0, padding: 0 }}>{role}</p>
            </div>
        </Card >
    )
}

export default PersonLabel;

const Card = styled('div', {
    background: 'rgba(255,255,255,0.12)',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    gap: '20px',
    backdropFilter: 'blur(3.5px)',
    border: '1px solid rgba(255,255,255, 0.12)',
    'p, h4': {
        width: 'max-content',
    },
    "@bp4": {
        paddingRight: '40px',
    }
})

const Image = styled('div', {
    'div': {
        background: 'transparent',
        margin: 0,
        'picture': {
            'img': {
                borderRadius: '50%',
                width: '100%',
                height: '100%',
                background: 'transparent',
            }
        }
    }
})
